<template>
  <div>
    <CardBase :headerBorder="false">
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <form
          class="form form-search"
          method="get"
          @submit.prevent="reloadTable"
        >
          <div class="form-search__row">
            <div class="form-search__single">
              <label class="form__label">Asset</label>
              <select class="form__input" v-model="formData.asset_id">
                <option value="">Please Choose</option>
                <option v-for="row in listAsset" :key="row.id" :value="row.id">
                  {{ row.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-search__row">
            <div class="form-search__double">
              <label class="form__label">Start Date</label>
              <date-picker
                v-model="formData.start_date"
                type="date"
                :editable="false"
                :clearable="false"
                input-class="form__input"
                value-type="YYYY-MM-DD"
                format="DD MMMM YYYY"
                placeholder="Start Date"
                @close="checkEndDate"
                :disabled-date="notAfterToday"
              ></date-picker>
            </div>
            <div class="form-search__double">
              <label class="form__label">End Date</label>
              <date-picker
                v-model="formData.end_date"
                type="date"
                :editable="false"
                :clearable="false"
                input-class="form__input"
                value-type="YYYY-MM-DD"
                format="DD MMMM YYYY"
                placeholder="End Date"
                :disabled-date="notBeforeStart"
              ></date-picker>
            </div>
          </div>

          <div class="form-search__action">
            <div class="w-6/12 flex">
              <BaseButton
                type="button"
                buttonClass="primary"
                @click="exportResults"
                >Download Report</BaseButton
              >
            </div>
          </div>
        </form>
      </template>
    </CardBase>
  </div>
</template>

<script>
import { datePickerMixin } from "@/mixins/datePickerMixin";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import DatePicker from "vue2-datepicker";

export default {
  data() {
    return {
      exportToken: null,
      listAsset: [],
      formData: {
        asset_id: "",
        start_date: null,
        end_date: null,
      },
    };
  },
  mixins: [datePickerMixin, getListAssetMixin],
  components: {
    DatePicker,
  },
  created() {
    this.getListAsset();
    this.formData.start_date = this.moment(new Date()).format("YYYY-MM-DD");
    this.formData.end_date = this.moment(new Date()).format("YYYY-MM-DD");
  },
  methods: {
    exportResults() {
      if (this.formData.asset_id) {
        window.open(
          process.env.VUE_APP_API_URL + "/export/deposit/" + this.exportToken
        );
      } else {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Please choose asset first",
          icon: "warning",
        });
      }
    },
    dateFormat(date) {
      return this.moment(date).format("DD MMM YYYY - HH:mm");
    },
  },
};
</script>